/* eslint-disable */
import Api from '@/api/services/Api';

const route = '/solicitud-pago'

export default {
    get: params => {
        // let customRoute = `${route}?expand=campus,departamento,status_description&search=${params.filter}`
        let newParam = {
            ...params,
            expand: 'campus,departamento,status_description',
            search: params.filter
        }

        switch (params.solicitudEstado) {
            case "2":
                // customRoute = `${route}?estado=1&expand=campus,departamento,status_description&search=${params.filter}`//sol pendientes
                newParam['estado'] = 1
                break;
            case "3":
                // customRoute = `${route}?estado=2&expand=campus,departamento,status_description&search=${params.filter}`//sol pagadas
                newParam['estado'] = 2
                break;
            // case "4":
                // customRoute = `${route}?estado=0&expand=campus,departamento,status_description&search=${params.filter}`//sol deshabilitadas
             //   newParam['estado'] = 0
             //   break;
            case "5":
                // customRoute = `${route}?${params.customfilter}&expand=campus,departamento,status_description&search=${params.filter}`//sol del dia
            case "6":
                //customRoute = `${route}?${params.customfilter}&expand=campus,departamento,status_description&search=${params.filter}`//aplicar filtro avanzado
            case "7":
                //customRoute = `${route}?${params.customfilter}&expand=campus,departamento,status_description&search=${params.filter}`//sol pagadas hoy
                newParam = {
                    ...newParam,
                    ...params.customfilter
                }
                break;
            default: break;
        }

        return Api().get(`${route}`, { params: newParam })
    },
    loadDetails: payload => Api().get(`${route}/${payload.id}?expand=campus,departamento,concepto,banco,tipo_monto,forma_pago,solicitud_pago_categoria,status_description`, { crossDomain: true }),
    post: payload => Api().post(`${route}?expand=campus,departamento,concepto,banco,tipo_monto,forma_pago,solicitud_pago_categoria,status_description`, payload),
    put: payload => Api().post(`${route}/${payload.get('id')}?expand=campus,departamento,concepto,banco,tipo_monto,forma_pago,solicitud_pago_categoria,status_description`, payload),
    getAllRecords: () => Api().get(`${route}?fields=id,razon_o_nombre&expand=status_description`, { crossDomain: true }),
    getHistory: payload => Api().get(`${route}/${payload.id}?expand=campus,departamento,concepto,banco,tipo_monto,forma_pago,solicitud_pago_categoria,status_description,history`, { crossDomain: true }),
    delete: payload => {
        const params = { expand: 'campus,departamento,status_description' }
        return Api().delete(`${route}/${payload.id}`, { params })
    },
    pay: payload => Api().put(`${route}/pay/${payload.id}?expand=campus,departamento,status_description`),
    getMontosTotal: () => Api().get(`${route}/monto`), //montos totales
    downloadFactura: (payload) => Api().get(`${route}/download-factura/${payload.id}`, {responseType: 'blob'}), //descargar factura
    downloadComprobante: (payload) => Api().get(`${route}/download-comprobante/${payload.id}`, {responseType: 'blob'}), //descargar comprobante
    export: params => Api().get(`${route}/export`, { params, responseType: 'blob' }) // exportar a excel
}
